<template>
  <div>
    <vs-popup 
      title="Cannot Continue"
      id="formative-assessments-marked-popup" 
      :active.sync="isTaskBlocked">
      <p class="pb-2">Well done on completing your Formative Assessments! Your answers will be assessed by a registered Assessor. You will receive a notification regarding the outcome.</p>
      <div class="mt-3">
        <vs-button color="success" class="float-right" @click="isTaskBlocked = false">Close</vs-button>
      </div>
    </vs-popup>
    
    <div id="lp-list" class="mx-4" :class="$route.name == 'PublicStudentDashboard' ? 'mt-0' : 'mt-24'">
      <div v-if="showLoading">
        <custom-skeleton size="larger" :count="$route.name == 'PublicStudentDashboard' ? 1 : 8" />
      </div>

      <div v-if="allLPs.length == 0 && !showLoading">
        <div style="height: 70vh;position: relative;">
          <div style="margin: 0;position: absolute;top: 50%;-ms-transform: translateY(-50%);transform: translateY(-50%);">
            <h3>You don't have any new Learning Programs to start</h3>
          </div>
        </div>
      </div>
      
      <div v-for="(course, i) in allLPs.map(function(item) {return item.courseName }).filter(function(value, index, self) {return (self.indexOf(value) === index)})" :key="i">
        <vs-divider v-if="$route.name != 'PublicStudentDashboard'"><h4>{{ course }}</h4></vs-divider>
        <div v-for="(_lp, index) in allLPs.filter(function(item){return (item.courseName == course) && (item.isMilestone === false)} )" :key="index">
          <div style="border-radius: 30px;" class="mb-3 border-3px cursor-pointer lp-item" :class="$route.name == 'PublicStudentDashboard' ? 'border-none' : $getSiteId() == 33 && _lp.lastTaskReached ? 'gen2-orange-border nav-dark-gradient-bg' : $getSiteId() == 35 && _lp.lastTaskReached ? 'gen2-pink-dark-border nav-dark-gradient-bg' : 'green-border gray-bg'">
            <div @click="openLP(_lp, _lp.isLearningStyleB)" :class="(selectedLP.id == _lp.moduleId && isLPDataVisible && _lp.isLearningStyleB) || (selectedLP.id == _lp.moduleId && !_lp.isLearningStyleB) ? 'lp-open' : ''">
              <div class="vx-row mx-3 mt-n3">
                <div class="vx-col self-center w-full">
                  <div class="vx-row">
                    <div class="vx-col self-center w-1/5 center-v-h">
                      <!-- <p class="gen2-large-numbers text-white">{{ calcNumberToShow(index + 1) }}</p> -->
                      <p class="gen2-large-numbers text-white">{{ calcNumberToShow(_lp.moduleNumber) }}</p>
                    </div>
                    <div class="vx-col self-center w-3/5 text-left">
                      
                    </div>
                    <div class="vx-col self-center w-1/5 center-v-h">
                      <custom-svg v-if="_lp.lastTaskReached" variant="check-circle" width="30" height="30" color="white" />
                      <custom-svg v-else variant="arrow" width="40" height="40" :dir="selectedLP.id == _lp.moduleId && isLPDataVisible && _lp.isLearningStyleB ? 'down' : 'right'" color="white" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="vx-row mx-3 mb-2 mt-n3">
                <div class="vx-col self-center w-full">
                  <div class="vx-row">
                    <div class="vx-col self-center w-1/6">
                      <feather-icon icon="CodesandboxIcon" class="text-white" svg-classes="stroke-current h-10 w-10"></feather-icon>
                    </div>
                    <div class="vx-col self-center w-5/6 text-left self-center lp-name">
                      <h4 class="w-full">
                        <span>{{ _lp.moduleName }}&nbsp;</span>
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <transition name="bounce">
              <div v-if="selectedLP.id == _lp.moduleId && isLPDataVisible && _lp.isLearningStyleB" class="vx-row mx-3 mb-2 lp-data">
                <div v-if="showLPDataLoading" class="vx-col self-center w-full p-0">
                  <custom-skeleton size="small" :count="5" />
                </div>
                <div v-else class="vx-col self-center w-full p-0">
                  <div id="map-item" v-if="Object.keys(mapTask).length != 0" @click="goToTask(mapTask)" class="lp-content-item" :class="mapTask.isTaskComplete ? 'gray-bg item-border-blue' : 'nav-white-bg item-border-green'">
                    <div class="vx-row">
                      <div class="vx-col self-center w-1/6 center-v-h">
                        <feather-icon icon="MapIcon" svg-classes="stroke-current h-8 w-8" :class="mapTask.isTaskComplete ? 'text-white' : 'font-brightgreen'"></feather-icon>
                      </div>
                      <div class="vx-col self-center w-2/3 text-left self-center">
                        <h5 :class="mapTask.isTaskComplete ? 'text-white' : 'font-brightgreen'">Map</h5>
                      </div>
                      <div class="vx-col self-center w-1/6 center-v-h">
                        <custom-svg v-if="mapTask.isTaskComplete" class="mt-n2" variant="check-circle" width="30" height="30" color="white" />
                        <custom-svg v-else class="mt-n2" variant="arrow" width="35" height="35" dir="right" color="green" />
                      </div>
                    </div>
                  </div>
                  <div id="intro-item" v-if="Object.keys(introductionVideoTask).length != 0" @click="goToTask(introductionVideoTask)" class="mt-2 lp-content-item" :class="!introductionVideoTask.isTaskComplete && mapTaskCompleted  ? 'nav-white-bg item-border-green' : mapTaskCompleted ? 'gray-bg item-border-blue' : 'gray-bg item-border-blue disabled'">
                    <div class="vx-row">
                      <div class="vx-col self-center w-1/6">
                        <feather-icon icon="InfoIcon" :class="!introductionVideoTask.isTaskComplete && mapTaskCompleted ? 'font-brightgreen' : 'text-white'" svg-classes="stroke-current h-8 w-8"></feather-icon>
                      </div>
                      <div class="vx-col self-center w-2/3 text-left self-center">
                        <h5 :class="!introductionVideoTask.isTaskComplete && mapTaskCompleted ? 'font-brightgreen' : 'text-white'">Introduction</h5>
                      </div>
                      <div class="vx-col self-center w-1/6">
                        <custom-svg v-if="!introductionVideoTask.isTaskComplete && mapTaskCompleted" class="mt-n2" variant="arrow" width="35" height="35" dir="right" color="green" />
                        <custom-svg v-else-if="mapTaskCompleted" class="mt-n2" variant="check-circle" width="30" height="30" color="white" />
                        <custom-svg v-else class="mt-n2" variant="lock" width="35" height="35" color="white" />
                      </div>
                    </div>
                  </div>
                  <div id="modules-container">
                    <div v-for="(_module, index) in distinctTaskGroups" :key="index" class="module-item mt-2 lp-content-item text-left" :class="isModuleLocked(_module.id) ? 'disabled gray-bg item-border-blue' : isModuleComplete(_module.id) ? 'nav-dark-gradient-bg item-border-blue' : 'nav-white-bg item-border-green'">
                      <div @click="openModule(_module.id)">
                        <div class="vx-row">
                          <div class="vx-col self-center w-1/6 center-v-h">
                            <feather-icon icon="GridIcon" :class="isModuleLocked(_module.id) || isModuleComplete(_module.id) ? 'text-white' : 'font-brightgreen'" svg-classes="stroke-current h-8 w-8"></feather-icon>
                          </div>
                          <div class="vx-col self-center w-2/3 text-left self-center">
                            <h5 :class="isModuleLocked(_module.id) || isModuleComplete(_module.id) ? 'text-white' : 'font-brightgreen'">{{ _module.taskGroupName }}</h5>
                          </div>
                          <div class="vx-col self-center w-1/6 center-v-h">
                            <custom-svg v-if="isModuleLocked(_module.id)" class="mt-n2" variant="lock" width="35" height="35" color="white" />
                            <custom-svg v-else-if="isModuleComplete(_module.id)" class="mt-n2" variant="check-circle" width="30" height="30" color="white" />
                            <custom-svg v-else class="mt-n2" variant="arrow" width="35" height="35" :dir="selectedModule == _module.id && isModuleDataVisible ? 'down' : 'right'" color="green" />
                          </div>
                        </div>
                      </div>
                      <transition name="bounce">
                        <div v-if="selectedModule == _module.id && isModuleDataVisible">
                          <div id="module-intro-item" v-if="Object.keys(introVideoForModule).length != 0" @click="goToTask(introVideoForModule)" class="mt-2 lp-content-item" :class="introVideoForModule.isTaskComplete ? 'nav-dark-gradient-bg item-border-blue' : 'nav-green-bg item-border-green'">
                            <div class="vx-row">
                              <div class="vx-col self-center w-1/6">
                                <feather-icon icon="InfoIcon" class="text-white" svg-classes="stroke-current h-8 w-8"></feather-icon>
                              </div>
                              <div class="vx-col self-center w-2/3 text-left self-center">
                                <h5 class="text-white">Introduction</h5>
                              </div>
                              <div class="vx-col self-center w-1/6">
                                <custom-svg v-if="introVideoForModule.isTaskComplete" class="mt-n2" variant="check-circle" width="30" height="30" color="white" />
                                <custom-svg v-else class="mt-n2" variant="arrow" width="35" height="35" dir="right" color="white" />
                              </div>
                            </div>
                          </div>
                          <div v-for="(_outcome, outcomeIndex) in getOutcomesForModule(_module.id)" :key="outcomeIndex" class="outcome-item mt-2 lp-content-item text-left" :class="isOutcomeLocked(_outcome.id, _module.id) ? 'disabled nav-white-bg item-border-light-gray' : isOutcomeOpen(_outcome.id, _module.id) ? 'nav-green-bg item-border-green' : isOutcomeComplete(_outcome.id, _module.id) ? 'nav-dark-gradient-bg item-border-blue': ''">
                            <div class="vx-row" @click="showOutcomeTasks(_outcome)">
                              <div class="vx-col w-1/6 center-v-h">
                                <feather-icon icon="ListIcon" :class="isOutcomeLocked(_outcome.id, _module.id) ? 'font-light-gray' : 'text-white'" svg-classes="stroke-current h-8 w-8"></feather-icon>
                              </div>
                              <div class="vx-col self-center w-2/3 text-left self-center">
                                <h5 :class="isOutcomeLocked(_outcome.id, _module.id) ? 'font-light-gray' : 'text-white'">{{ _outcome.taskSpecificOutcomeName }}</h5>
                              </div>
                              <div class="vx-col w-1/6 center-v-h">
                                <custom-svg v-if="isOutcomeLocked(_outcome.id, _module.id)" class="mt-n2" variant="lock" width="35" height="35" color="gray" />
                                <custom-svg v-else-if="isOutcomeComplete(_outcome.id, _module.id)" class="mt-n2" variant="check-circle" width="30" height="30" color="white" />
                                <custom-svg v-else class="mt-n2" variant="arrow" width="35" height="35" dir="right" color="white" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </transition>
                    </div>
                  </div>
                  <div id="additional-material-item" v-if="Object.keys(additionalMaterialTask).length != 0" @click="goToTask(additionalMaterialTask)" class="mt-2 lp-content-item" :class="additionalMaterialTask.isTaskComplete ? 'nav-dark-gradient-bg item-border-blue' : additionalMaterialTask.isTaskOpen ? 'nav-white-bg item-border-green' : 'nav-light-gray-bg item-border-blue disabled' ">
                    <div class="vx-row">
                      <div class="vx-col self-center w-1/6">
                        <feather-icon icon="LayersIcon" :class="additionalMaterialTask.isTaskComplete ? 'text-white' : additionalMaterialTask.isTaskOpen && !additionalMaterialTask.isTaskComplete ? 'font-brightgreen' : 'text-white'" svg-classes="stroke-current h-8 w-8"></feather-icon>
                      </div>
                      <div class="vx-col self-center w-2/3 text-left self-center">
                        <h5 :class="additionalMaterialTask.isTaskComplete ? 'text-white' : additionalMaterialTask.isTaskOpen && !additionalMaterialTask.isTaskComplete ? 'font-brightgreen' : 'text-white'">Additional Material</h5>
                      </div>
                      <div class="vx-col self-center w-1/6">
                        <custom-svg v-if="additionalMaterialTask.isTaskOpen && !additionalMaterialTask.isTaskComplete" class="mt-n2" variant="arrow" width="35" height="35" dir="right" color="green" />
                        <custom-svg v-else-if="additionalMaterialTask.isTaskComplete" class="mt-n2" variant="check-circle" width="30" height="30" color="white" />
                        <custom-svg v-else class="mt-n2" variant="lock" width="35" height="35" color="white" />
                      </div>
                    </div>
                  </div>
                  <div id="log-activity-item" v-if="$getSiteId() == 35 && _lp.logActivity" @click="$router.push({ name: 'Gen2PracticalTimeCapture' })" class="mt-2 lp-content-item" :class="_lp.lastTaskReached ? 'nav-white-bg item-border-green' : 'nav-light-gray-bg item-border-blue disabled' ">
                    <div class="vx-row">
                      <div class="vx-col self-center w-1/6">
                        <feather-icon icon="ClockIcon"  :class="_lp.lastTaskReached ? 'font-brightgreen' : 'text-white'" svg-classes="stroke-current h-8 w-8"></feather-icon>
                      </div>
                      <div class="vx-col self-center w-2/3 text-left self-center">
                        <h5 :class="_lp.lastTaskReached ? 'font-brightgreen' : 'text-white'">Log Activity</h5>
                      </div>
                      <div class="vx-col self-center w-1/6">
                        <custom-svg v-if="_lp.lastTaskReached" class="mt-n2" variant="arrow" width="35" height="35" dir="right" color="green" />
                        <custom-svg v-else class="mt-n2" variant="lock" width="35" height="35" color="white" />
                      </div>
                    </div>
                  </div>
                  <!-- <div id="prac-assessment-item" class="nav-dark-gradient-bg mt-2 lp-content-item item-border-blue">
                    <div class="vx-row">
                      <div class="vx-col self-center w-1/6">
                        <feather-icon icon="CheckSquareIcon" class="text-white" svg-classes="stroke-current h-8 w-8"></feather-icon>
                      </div>
                      <div class="vx-col self-center w-2/3 text-left self-center">
                        <h5>Practical Assessment</h5>
                      </div>
                      <div class="vx-col self-center w-1/6">
                        <custom-svg class="mt-n2" variant="check-circle" width="30" height="30" color="white" />
                      </div>
                    </div>
                  </div> -->
                </div>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomSvg from '@/gen-2/components/CustomSVG.vue';
export default {
  components: {
    CustomSvg
  },
  data() {
    return {
      showLoading: false,
      selectedLP: { //module
        id: null,
        name: null,
        number: null
      },
      isLPDataVisible: false,
      selectedModule: null, //taskGroup
      isModuleDataVisible: false,
      data: [],
      allLPs: [],
      availableModules: [],
      modulesForBackpack: [],
      continueMilestones: [],
      introductionVideoTask: {},
      mapTask: {},
      lpData: [],
      additionalMaterialTask: {},
      mapTaskCompleted:false,
      introductionVideoTaskCompleted:false,
      prerequisiteModuleName: null,
      prerequisiteModuleLen: null,
      distinctTaskGroups: [],
      showLPDataLoading: false,
      timeCapture:{
        captureTimeForAssessments: false,
        formativeHoursRequired: null,
        summativeHoursRequired: null,
        sliderMinFormatives: 0,
        sliderMaxFormatives: 0,
        sliderMinSummatives: 0,
        sliderMaxSummatives: 0,
        taskClassificationTypeId: 0,
      },
      isTaskBlocked:false,
      introVideoForModule:[],
      coins: null,
      lpToContinueFrom: {
        lp: {
          moduleId: null,
          name: null,
          number: null
        },
        moduleId: null,
        outcomeId: null
      },
      hasLPToContinueFromInLocalStorage: false
    };
  },
  computed: {
    
  },
  methods: {
    loadMenuData(studentId) {
      var self = this;

      var onSuccess = function (response) {
        self.data = response.data;
        self.allLPs = self.data;
        self.availableModules = self.data.map(x => x.moduleId);
        self.continueMilestones = self.data.filter(function(item) { return item.isMilestone }).sort((a, b) => Date.parse(a.sortDate) < Date.parse(b.sortDate) ? 1 : -1);
        self.modulesForBackpack = JSON.stringify(self.data.map((item) => {return {label: item.moduleName, value: item.moduleId} }));

        if (self.$route.params && self.$route.params.lp && self.$route.params.lp.moduleId) {
          self.openLP(self.$route.params.lp, true, true);
        } else if (self.hasLPToContinueFromInLocalStorage && self.$route.query.ref == "continue") {
          var cachedLP = JSON.parse(localStorage.getItem("lpToContinueFrom"));
          self.openLP(cachedLP.lp, true, true);
        }

        localStorage.setItem("StudentModules", self.modulesForBackpack);
      };
      var onFinally = function () {
        self.showLoading = false;
      };

      self.$ajaxGet(self, "Student/LoadMenu?studentId=" + studentId, onSuccess, onFinally);
    },
    getModuleInformation(id) {
      var self = this;

      var onSuccess = function (response) {
        self.data = response.data;
        self.allLPs.push(self.data);

        setTimeout(() => {
          self.openLP(self.data, true, true);
        }, 100);
      };
      var onFinally = function () {
        self.showLoading = false;
      };

      self.$ajaxGet(self, "Module/GetModuleInformation/" + id, onSuccess, onFinally);
    },
    openLP(lp, isStyleB, openFromNavigation) {
      var self = this;
      self.initLPValues();

      if (isStyleB) {
        if (self.isLPDataVisible && self.selectedLP.id == lp.moduleId) {
          self.isLPDataVisible = false;
          self.selectedLP.id = null;
          self.selectedLP.name = null;
          self.selectedLP.number = null;
          self.lpToContinueFrom.lp = {
            moduleId: null,
            name: null,
            number: null
          };
          self.lpToContinueFrom.moduleId = null;
          self.lpToContinueFrom.outcomeId = null;
          localStorage.removeItem("lpToContinueFrom");
        } else {
          self.showLPDataLoading = true;
          self.getLPData(lp.moduleId, () => { self.checkNextToDo(); });
          self.selectedLP.id = lp.moduleId;
          self.selectedLP.name = lp.moduleName || lp.name;
          self.selectedLP.number = self.calcNumberToShow(lp.moduleNumber || parseInt(lp.lpNumber) || parseInt(lp.number));

          self.lpToContinueFrom.lp = {
            moduleId: self.selectedLP.id,
            name: self.selectedLP.name,
            number: self.selectedLP.number
          }

          localStorage.setItem("lpToContinueFrom", JSON.stringify(self.lpToContinueFrom));

          self.isLPDataVisible = true;

          if (openFromNavigation && document.getElementsByClassName("lp-open") && document.getElementsByClassName("lp-open").length > 0) {
            setTimeout(() => {
              var openLPElement = document.getElementsByClassName("lp-open")[0];
              openLPElement.scrollIntoView();
              window.scrollBy(0, -100);
            }, 100);
          }
        }
      } else {

        self.selectedLP.id = lp.moduleId;
        self.selectedLP.name = lp.moduleName || lp.name;
        self.selectedLP.number = self.calcNumberToShow(lp.moduleNumber || parseInt(lp.lpNumber) || parseInt(lp.number));

        self.lpToContinueFrom.lp = {
          moduleId: self.selectedLP.id,
          name: self.selectedLP.name,
          number: self.selectedLP.number
        }
        self.lpToContinueFrom.moduleId = null;
        self.lpToContinueFrom.outcomeId = null;

        localStorage.setItem("lpToContinueFrom", JSON.stringify(self.lpToContinueFrom));

        if (openFromNavigation) {
          setTimeout(() => {
            var openLPElement = document.getElementsByClassName("lp-open")[0];
            openLPElement.scrollIntoView();
            window.scrollBy(0, -100);
          }, 100);
        }
        if(lp.isNew){
          self.startNew(lp.moduleId, lp.taskDisplayId, lp.allowContinuousAssessment);
        }
        else
        {
          self.continue(lp);
        }
      }

      
    },
    initLPValues() {
      this.introductionVideoTask = {};
      this.mapTask = {};
      this.lpData = [];
      this.additionalMaterialTask = {};
      this.mapTaskCompleted = false;
      this.introductionVideoTaskCompleted = false;
      this.prerequisiteModuleName = null;
      this.prerequisiteModuleLen = null;
      this.distinctTaskGroups = [];
    },
    getLPData(id, whenDone){
      var self = this;
      var onSuccess = function (response) {
        self.introductionVideoTask = response.data.filter(x=> x.taskName.includes("IntroductionVideoTask"))[0];
        if (!self.introductionVideoTask) {
          self.introductionVideoTask = {};
        }

        self.additionalMaterialTask = response.data.filter(x=> x.taskName.includes("AdditionalMaterialTask"))[0];
        if (!self.additionalMaterialTask) {
          self.additionalMaterialTask = {};
        }

        self.mapTask = response.data.filter(x=> x.taskName.includes("MapTask"))[0];
        if (!self.mapTask) {
          self.mapTask = {};
        }

        self.lpData = response.data.filter(x=> !x.taskName.includes("IntroductionVideoTask") && !x.taskName.includes("AdditionalMaterialTask") && !x.taskName.includes("MapTask"));
        //check if Map Task is complete
        if(Object.keys(self.mapTask).length != 0){
          self.mapTaskCompleted = self.mapTask.isTaskComplete;
        }
        else{
          self.mapTaskCompleted = true;
        }
        //check if Introduction Video is complete
        if(Object.keys(self.introductionVideoTask).length != 0){
          self.introductionVideoTaskCompleted = self.introductionVideoTask.isTaskComplete;
        }
        else{
          self.introductionVideoTaskCompleted = true;
        }

        if(self.$route.name != "PublicStudentDashboard") {
          self.getTimeCaptureDetail();
        }
        

        // self.getPrerequisiteModuleName();

        self.getDistinctTaskGroups(whenDone);
      };
      var onFinally = function (response) {
        self.showLPDataLoading = false;
      }

      self.$ajaxGet(self, "StudentModule/GetLearingStyleBModuleData?moduleId=" + id, onSuccess, onFinally);
    },
    getPrerequisiteModuleName(){
      var self = this;

      self.prerequisiteModuleName = self.lpData.filter(x => x.prerequisiteModuleName && !x.isTaskLocked);
      self.prerequisiteModuleLen = self.prerequisiteModuleName.length;

      if(self.prerequisiteModuleLen){
        self.prerequisiteModuleName = self.prerequisiteModuleName[self.prerequisiteModuleLen - 1].prerequisiteModuleName;
      }
    },
    isMapTaskCompleted(){
      var self = this;
      if(Object.keys(self.mapTask).length != 0){
        self.mapTaskCompleted = self.mapTask.isTaskComplete;
        return self.mapTask.isTaskComplete;
      }
      else
        return true;
    },
    isIntroVideoTaskCompleted(){
      var self = this;
      if(Object.keys(self.introductionVideoTask).length != 0){
        self.introductionVideoTaskCompleted = self.introductionVideoTask.isTaskComplete;
        return self.introductionVideoTask.isTaskComplete;
      }
      else
        return true;
    },
    isModuleComplete(moduleId){
      var self = this;

      var moduleList = self.lpData.filter(x => x.taskGroupId == moduleId);

      var isCompleteList = moduleList.filter(x => x.isTaskComplete);

      if(isCompleteList.length == moduleList.length)
        return true;
      else
        return false;
    }, 
    isModuleLocked(moduleId){
      var self = this;
      var moduleList = self.lpData.filter(x => x.taskGroupId == moduleId);
      var isLockedList = moduleList.filter(x => x.isTaskLocked);
      // var isLockedList = moduleList.filter(x => x.isTaskLocked || (!x.isTaskLocked && !x.isTaskOpen && !x.isTaskComplete));
      // if((isLockedList.length == moduleList.length) && self.isMapTaskCompleted())
      if((isLockedList.length == moduleList.length) || !(self.isIntroVideoTaskCompleted() && self.isMapTaskCompleted()))
        return true;
      else
        return false;
    },
    getDistinctTaskGroups(whenDone){
      var self = this;
      self.distinctTaskGroups = Array.from(new Set(self.lpData.map(x => x.taskGroupId))).map(id => {
        return {
          id: id,
          taskGroupName: self.lpData.find(x => x.taskGroupId == id).taskGroupName,
          taskSpecificOutcomeId: self.lpData.find(x => x.taskGroupId == id).taskSpecificOutcomeId,
          taskGroupNumber: self.lpData.find(x => x.taskGroupId == id).taskGroupNumber
        }
      });
      self.distinctTaskGroups = self.distinctTaskGroups.sort(function(a,b){
        var sort1 = a.taskGroupNumber, sort2 = b.taskGroupNumber;
        if(sort1 < sort2)
          return -1;
        if(sort1 > sort2)
          return 1;
        return 0;
      });

      if (whenDone && typeof whenDone == "function")
        whenDone();
      else {
        if (self.$route.params.selectedTaskGroup) {
          self.openModule(self.$route.params.selectedTaskGroup);
          // if (!self.isModuleComplete(self.$route.params.selectedTaskGroup)) {
          //   self.openModule(self.$route.params.selectedTaskGroup);
          // }
        } else if (self.hasLPToContinueFromInLocalStorage && self.$route.query.ref == "continue" && JSON.parse(localStorage.getItem("lpToContinueFrom")).moduleId) {
          var cachedLP = JSON.parse(localStorage.getItem("lpToContinueFrom"));
          self.openModule(cachedLP.moduleId);
        }
      }
    },
    openModule(id) {
      this.introVideoForModule = this.lpData.filter(x => x.taskGroupId == id && x.taskName.includes("IntroductionVideo " + x.taskGroupName) )[0];
      if (!this.introVideoForModule) {
        this.introVideoForModule = {};
      }

      if (this.isModuleDataVisible && this.selectedModule == id) {
        this.isModuleDataVisible = false;
        this.selectedModule = null;
        this.lpToContinueFrom.moduleId = null;
      } else if (this.isModuleDataVisible && this.selectedModule != id) {
        this.selectedModule = id;
        this.lpToContinueFrom.moduleId = id;
      } else if (!this.isModuleDataVisible) {
        this.lpToContinueFrom.moduleId = id;
        this.selectedModule = id;
        this.isModuleDataVisible = true;
      }

      localStorage.setItem("lpToContinueFrom", JSON.stringify(this.lpToContinueFrom));
    },
    checkNextToDo() {
      var self = this;

      self.isModuleDataVisible = false;
      self.selectedModule = null;

      if (self.introductionVideoTaskCompleted && self.mapTaskCompleted) {
        var incompleteModules = self.distinctTaskGroups.filter(x => !self.isModuleComplete(x.id));
        if (incompleteModules.length > 0) {
          var firstIncompleteModule = incompleteModules[0];
          setTimeout(() => {
            self.openModule(firstIncompleteModule.id);
          }, 50);
        }
      }
    },
    getOutcomesForModule(moduleId){
      var self = this;
      return Array.from(new Set(self.lpData.filter(x=>x.taskGroupId == moduleId && !x.taskName.includes("IntroductionVideo ")).map(x=> x.taskSpecificOutcomeId))).map(id => {
        return {
          id: id, 
          taskSpecificOutcomeName: self.lpData.find(x=>x.taskSpecificOutcomeId == id).taskSpecificOutcomeName,
          moduleId: self.lpData.find(x=>x.taskSpecificOutcomeId == id).moduleId,
          taskClassificationTypeId: self.lpData.find(x=>x.taskSpecificOutcomeId == id).taskClassificationTypeId
        }
      });

      // return self.lpData.filter(x => x.taskGroupId == moduleId && !x.taskName.includes("IntroductionVideo ")).map(x => { return { id: x.taskSpecificOutcomeId, taskSpecificOutcomeName: x.taskSpecificOutcomeName, moduleId: x.moduleId, taskClassificationTypeId: x.taskClassificationTypeId } });
    },
    isOutcomeOpen(outcomeId, moduleId){
      var self = this;
      var outcomeList = self.lpData.filter(x => x.taskSpecificOutcomeId == outcomeId && x.taskGroupId == moduleId);
      var isOpenList = outcomeList.filter(x => x.isTaskOpen);

      if(isOpenList.length > 0)
        return true;
      else
        return false;
    },
    isOutcomeLocked(outcomeId, moduleId){
      var self = this;
      var outcomeList = self.lpData.filter(x => x.taskSpecificOutcomeId == outcomeId && x.taskGroupId == moduleId);
      var isLockedList = outcomeList.filter(x => x.isTaskLocked && !x.isTaskComplete);

      if(isLockedList.length == outcomeList.length)
        return true;
      else
        return false;
    },
    isOutcomeComplete(outcomeId, moduleId){
      var self = this;
      var outcomeList = self.lpData.filter(x => x.taskSpecificOutcomeId == outcomeId && x.taskGroupId == moduleId);
      var isLockedList = outcomeList.filter(x => x.isTaskComplete);

      if(isLockedList.length == outcomeList.length)
        return true;
      else
        return false;
    },
    showOutcomeTasks(outcome) {
      var self = this;
      // var taskList = self.lpData.filter(x => x.taskSpecificOutcomeId == outcome.id && x.taskGroupId == self.selectedModule);
      
      self.$router.push({ name: self.$route.name == 'PublicStudentDashboard' ? 'PublicOutcomeTasks' : 'Gen2OutcomeTasks', query: {
        moduleId: self.selectedLP.id,
        lpName: self.selectedLP.name,
        lpNumber: self.selectedLP.number,
        selectedTaskGroup: self.selectedModule,
        selectedOutcome: outcome.id,
        timeCapture: JSON.stringify(self.timeCapture)
      }});
    },
    calcNumberToShow(number) {
      return (number < 10) ? `0${number}` : number;
    },
    getTimeCaptureDetail(){
      var self = this;
      self.timeCapture.captureTimeForAssessments = self.lpData[0].captureTimeForAssessments;
      self.timeCapture.formativeHoursRequired = self.lpData[0].formativeHoursRequired;
      self.timeCapture.summativeHoursRequired = self.lpData[0].summativeHoursRequired;

      var formativesCount = self.lpData.filter(x => x.taskClassificationTypeId == 1).length;
      var summativesCount = self.lpData.filter(x => x.taskClassificationTypeId == 2).length;

      self.timeCapture.sliderMinFormatives = Math.ceil(self.timeCapture.formativeHoursRequired/formativesCount);
      self.timeCapture.sliderMinSummatives = Math.ceil(self.timeCapture.summativeHoursRequired/summativesCount);

      self.timeCapture.sliderMaxFormatives = Math.ceil(self.timeCapture.sliderMinFormatives + (self.timeCapture.sliderMinFormatives * 50/100));
      self.timeCapture.sliderMaxSummatives = Math.ceil(self.timeCapture.sliderMinSummatives + (self.timeCapture.sliderMinSummatives * 50/100));
      
    },
    goToTask(task){
      var self = this;
      var checkIfPreview = self.$acl.check("Student");
      if(!checkIfPreview){
        if(task.taskTypeId == 9 ){
          self.$router.push({ name: 'StoryViewer', params: {
            mode: "story",
            taskDisplayId: task.taskDisplayId,
            moduleId: self.selectedLP.id,
            isStudent: "false",
            coins: self.coins,
            styleB: true,
            taskClassificationTypeId: 9,
            lpName: self.selectedLP.name,
            lpNumber: self.selectedLP.number,
            selectedTaskGroup: self.selectedModule
          }, query: {
            ref: self.$route.name == 'PublicStudentDashboard' ? "public" : "sonke",
            moduleId: self.selectedLP.id,
            lpName: self.selectedLP.name,
            lpNumber: self.selectedLP.number,
            selectedTaskGroup: self.selectedModule,
            timeCapture: JSON.stringify(self.timeCapture),
          }});
        }else if(task.taskTypeId == 2){
            self.$router.push({ name: self.$route.name == 'PublicStudentDashboard' ? "PublicVideoViewer" : "Gen2VideoViewer", query: {
              id: task.taskId,
              moduleId: self.selectedLP.id,
              styleB: true,
              taskClassificationTypeId: 9,
              lpName: self.selectedLP.name,
              lpNumber: self.selectedLP.number,
              selectedTaskGroup: self.selectedModule,
              timeCapture: JSON.stringify(self.timeCapture),
            }});
        }else if(task.taskTypeId == 5){
          self.$router.push({ name: self.$route.name == 'PublicStudentDashboard' ? "PublicDocumentViewer" : "Gen2DocumentViewer", query: {
            id: task.taskId,
            moduleId: self.selectedLP.id,
            styleB: true,
            taskClassificationTypeId: 9,
            lpName: self.selectedLP.name,
            lpNumber: self.selectedLP.number,
            selectedTaskGroup: self.selectedModule,
            scrollable: task.scrollable
          }});
        }else if(task.taskTypeId == 6){
          self.$router.push({ name: self.$route.name == 'PublicStudentDashboard' ? "PublicUploadViewer" : "Gen2UploadViewer", query: {
            id: task.taskId,
            moduleId: self.selectedLP.id,
            styleB: true,
            taskClassificationTypeId: 9,
            timeCapture: JSON.stringify(self.timeCapture),
            lpName: self.selectedLP.name,
            lpNumber: self.selectedLP.number,
            selectedTaskGroup: self.selectedModule
          }});
        }else if(task.taskTypeId == 8){
          self.$router.push({ name: 'StoryViewer', params: {
            mode: "story",
            taskDisplayId: task.taskDisplayId,
            moduleId: self.selectedLP.id,
            isStudent: "false",
            coins: self.coins,
            styleB: true,
            taskClassificationTypeId: 9,
            lpName: self.selectedLP.name,
            lpNumber: self.selectedLP.number,
            selectedTaskGroup: self.selectedModule
          }, query: {
            ref: self.$route.name == 'PublicStudentDashboard' ? "public" : "sonke",
            moduleId: self.selectedLP.id,
            lpName: self.selectedLP.name,
            lpNumber: self.selectedLP.number,
            selectedTaskGroup: self.selectedModule,
            timeCapture: JSON.stringify(self.timeCapture),
          }});
        }
      }
      else{
        var onSuccess = response =>{
          if((task.taskClassificationTypeId == 2) && (response.data == 2 || response.data == 1)){
            self.isTaskBlocked = true;
            return;
          }
          else{
            if(task.taskTypeId == 9 ){
              self.$router.push({ name: 'StoryViewer', params: {
                mode: "story",
                taskDisplayId: task.taskDisplayId,
                moduleId: self.selectedLP.id,
                isStudent: "true",
                coins: self.coins,
                styleB: true,
                taskClassificationTypeId: task.taskClassificationTypeId,
                lpName: self.selectedLP.name,
                lpNumber: self.selectedLP.number,
                selectedTaskGroup: self.selectedModule
              }, query: {
                ref: self.$route.name == 'PublicStudentDashboard' ? "public" : "sonke",
                moduleId: self.selectedLP.id,
                lpName: self.selectedLP.name,
                lpNumber: self.selectedLP.number,
                selectedTaskGroup: self.selectedModule,
                timeCapture: JSON.stringify(self.timeCapture),
              }});
            }else if(task.taskTypeId == 2){
              self.$router.push({ name: self.$route.name == 'PublicStudentDashboard' ? "PublicVideoViewer" : "Gen2VideoViewer", query: {
                id: task.taskId,
                moduleId: self.selectedLP.id,
                styleB: true,
                taskClassificationTypeId: task.taskClassificationTypeId,
                lpName: self.selectedLP.name,
                lpNumber: self.selectedLP.number,
                selectedTaskGroup: self.selectedModule,
                timeCapture: JSON.stringify(self.timeCapture),
              }});
            }else if(task.taskTypeId == 5){
              self.$router.push({ name: self.$route.name == 'PublicStudentDashboard' ? "PublicDocumentViewer" : "Gen2DocumentViewer", query: {
                id: task.taskId,
                moduleId: self.selectedLP.id,
                styleB: true,
                taskClassificationTypeId: task.taskClassificationTypeId,
                lpName: self.selectedLP.name,
                lpNumber: self.selectedLP.number,
                selectedTaskGroup: self.selectedModule,
                scrollable: task.scrollable
              }});
            }else if(task.taskTypeId == 6){
              self.$router.push({ name: self.$route.name == 'PublicStudentDashboard' ? "PublicUploadViewer" : "Gen2UploadViewer", query: {
                id: task.taskId,
                moduleId: self.selectedLP.id,
                styleB: true,
                taskClassificationTypeId: task.taskClassificationTypeId,
                timeCapture: JSON.stringify(self.timeCapture),
                lpName: self.selectedLP.name,
                lpNumber: self.selectedLP.number,
                selectedTaskGroup: self.selectedModule
              }});
            }else if(task.taskTypeId == 8){
              self.$router.push({ name: 'StoryViewer', params: {
                mode: "story",
                taskDisplayId: task.taskDisplayId,
                moduleId: self.selectedLP.id,
                isStudent: "true",
                coins: self.coins,
                styleB: true,
                taskClassificationTypeId: task.taskClassificationTypeId,
                lpName: self.selectedLP.name,
                lpNumber: self.selectedLP.number,
                selectedTaskGroup: self.selectedModule
              }, query: {
                ref: self.$route.name == 'PublicStudentDashboard' ? "public" : "sonke",
                moduleId: self.selectedLP.id,
                lpName: self.selectedLP.name,
                lpNumber: self.selectedLP.number,
                selectedTaskGroup: self.selectedModule,
                timeCapture: JSON.stringify(self.timeCapture),
              }});
            }
          }
        };
        
        self.$ajaxGet(self, "StudentModule/GetStudentModuleStatusId?studentId=" + self.currentStudentId + "&moduleId=" + task.moduleId, onSuccess);
      };
      
    },
    startNew(moduleId, taskDisplayId, allowContinuousAssessment) {
      var self = this;

      if(moduleId && taskDisplayId){

        var status = allowContinuousAssessment ? 9 : 2;

          localStorage.setItem("currentModule", moduleId);

          self.$router.push({ name: 'StoryViewer', params: {
            mode: "story",
            taskDisplayId: taskDisplayId,
            moduleId: moduleId,
            isStudent: "true",
            coins: null
          }, query: {
            ref: self.$route.name == 'PublicStudentDashboard' ? "public" : "sonke",
          }});
      }
    },
    continue(module) {
      var self = this;

      if(module.moduleId, module.taskDisplayId){
        localStorage.setItem("currentModule", module.moduleId);

        self.$router.push({ name: 'StoryViewer', params: {
          mode: "story",
          taskDisplayId: module.taskDisplayId,
          moduleId: module.moduleId,
          isStudent: "true",
          coins: null
        }, query: {
          ref: self.$route.name == 'PublicStudentDashboard' ? "public" : "sonke",
        }});
      }
    },
    getCourseEndTaskId(){
      var self = this;
      if (self.$route.name == "PublicStudentDashboard") {
        var onSuccess = response =>{
          if(response.data)
          {
            this.onCompletePopup()
          }
        }
        self.$ajaxGet(self, "Student/getIsStudentDoneWithModule?moduleId=" + self.$route.query.id, onSuccess);
      }
      
    },
    onCompletePopup(){
      var self = this;
      self.$swal({
          title: 'Congratulations on completing your course!',
          icon: 'success',
          html: "Please note that you still have access to this course to complete it as many times as you like!",
          customClass: {
            confirmButton: 'vs-component vs-button vs-button-primary vs-button-filled',
          },
          showClass: {
            popup: 'animate__animated animate__bounceIn',
          },
          buttonsStyling: false,
        })

    }
  },
  mounted() {
    var self = this;
    self.showLoading = true;
    self.currentStudentId = localStorage.getItem('Current_User_Id');

    self.lpToContinueFrom = JSON.parse(localStorage.getItem("lpToContinueFrom"));
    self.hasLPToContinueFromInLocalStorage = localStorage.getItem("lpToContinueFrom") && (Object.keys(self.lpToContinueFrom).length != 0);

    if (!self.hasLPToContinueFromInLocalStorage || !localStorage.getItem("lpToContinueFrom")) {
      self.lpToContinueFrom = {};
      self.lpToContinueFrom.lp = {};
      self.lpToContinueFrom.lp.moduleId = null;
      self.lpToContinueFrom.lp.name = null;
      self.lpToContinueFrom.lp.number = null;
      self.lpToContinueFrom.number = null;
      self.lpToContinueFrom.outcomeId = null;
    }

    if (self.$route.name == 'PublicStudentDashboard') {
      self.getModuleInformation(self.$route.query.id)
    } else {
      self.loadMenuData(self.currentStudentId);
    }
    
    self.getCourseEndTaskId();
  },
  created() {
    if (!this.$route.query.ref)
      window.scrollTo(0,0);
  }
};
</script>